import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';

import { ExpenseReportItem } from '@/features/slice/report';
import { formatCurrencyInBDT } from '@/utils';

export const expenseReportColumns: ColumnDef<ExpenseReportItem>[] = [
    {
        accessorKey: 'created_at',
        header: 'Time',
        cell: ({ row }) => (
            <span>
                {format(row.original.created_at, 'dd-MM-yyyy (HH:mm a)')}
            </span>
        ),
    },

    {
        accessorKey: 'description',
        header: 'Description',
        cell: ({ row }) => <span>{row.original.description}</span>,
    },

    {
        accessorKey: 'category_name',
        header: 'Category',
        cell: ({ row }) => <span>{row.original.category_name}</span>,
    },

    {
        accessorKey: 'amount',
        header: () => (
            <span className={'block text-right font-medium'}>Amount</span>
        ),
        cell: ({ row }) => (
            <span className={'block text-right'}>
                {formatCurrencyInBDT(row.original.amount)}
            </span>
        ),
    },
];
